import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { VENDOR_CHANGE_PASSWORD_REQUEST } from "./type";
import { vendorChangePasswordSuccess } from "./action";
import { ApiResponseMessage } from "../../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../../constant/commonConstants";
import { invokeApi } from "../../../../helper/axiosHelper";

function* changePassword({ payload: data }) {
    try {
        const res = yield call(
            invokeApi,
            "post",
            "/changePassword",
            data,
            {},
            "vendor"
        );
        yield put(vendorChangePasswordSuccess(res));
        ApiResponseMessage(res.message, res.status ? SUCCESS : DANGER);
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    }
}

function* watchVendorChangePasswordRequest() {
    yield takeLatest(VENDOR_CHANGE_PASSWORD_REQUEST, changePassword);
}

function* VendorChangePasswordSaga() {
    yield all([fork(watchVendorChangePasswordRequest)]);
}

export default VendorChangePasswordSaga;
